<nb-card>
  <nb-card-header>
    <span>{{ inspectionText()}}</span>
    <div class="spacer"></div>
    <nb-button-group (valueChange)="inspectionMode.set($event[0])">
      <button nbButtonToggle value="active" [pressed]="inspectionMode() === 'active'">Aktiv</button>
      <button nbButtonToggle value="upcoming" [pressed]="inspectionMode() === 'upcoming'">Geplant</button>
      <button nbButtonToggle value="sent" [pressed]="inspectionMode() === 'sent'">Abgeschlossene</button>
    </nb-button-group>

  </nb-card-header>
  <wr-table [rows]="inspections()"
            [loading]="isLoading()"
            [(sort)]="sort"
            [rowLink]="getInspectionLink"
  >
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="FolgeNr."
                 shrink
                 sort="continuationNumber">
      {{inspection.continuationNumber}}
    </ng-template>
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="Status"
                 shrink
                 sort="status"><wr-status-text [status]="inspection.status" /></ng-template>
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="Datum"
                 shrink
                 sort="fromTimestamp">{{inspection.fromTimestamp | date: 'dd.MM.yyyy'}}</ng-template>
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="Adresse">{{inspection.building.baseData.sectionText}}</ng-template>
    <wr-table-pagination [totalRows]="inspectionCount()"
                         [(pageSize)]="pageSize"
                         [(page)]="page"></wr-table-pagination>
  </wr-table>
</nb-card>
